import { convertTimeToDisplayString } from '../date-utils';
import { AuditLogResponseItem, PostRegEditLogDisplay } from './types';

export const getDateString = (
  insertedAt: string,
  orgTimezoneIana?: string
): string => {
  try {
    const timeZone =
      orgTimezoneIana ||
      Intl.DateTimeFormat().resolvedOptions().timeZone ||
      'America/New_York';
    const formattedOrgTime = convertTimeToDisplayString(insertedAt, timeZone);
    return `${formattedOrgTime} (${timeZone})`;
  } catch (e) {
    return insertedAt;
  }
};

export const formatAuditLogsForDisplay = (
  auditLogs: AuditLogResponseItem[]
): PostRegEditLogDisplay[] => {
  const dateHash = {};
  auditLogs
    .sort(
      (a, b) =>
        new Date(b.insertedAt).getTime() - new Date(a.insertedAt).getTime()
    )
    .forEach((log) => {
      const date = log.insertedAt;
      if (!dateHash[date]) {
        dateHash[date] = [];
      }
      dateHash[date].push(log);
    });
  return Object.entries(dateHash).map(
    ([key, value]) =>
      ({
        updatedAt: key,
        details: (value as AuditLogResponseItem[]).map((log) => {
          const updatedByDisplay = log.updatedByDisplay || 'Admin';
          const notes = log.notes;
          return { notes, updatedByDisplay };
        }),
      } as PostRegEditLogDisplay)
  );
};
